import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { NestApiProvider } from '../nest-api';
import { ResponseData } from '../nest-responses';

@Injectable()
export class PurchaseContractApi {

  private service: string = '';
  private model: string = 'erp/purchasecontract';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public getRequestDetail(payload: { requestNo: string}): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getRequestDetail';
    const params: any = payload || {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/erp/purchasecontract.api.ts